import React from 'react';
import { View, Text, TouchableOpacity, ViewStyle } from 'react-native';
import { RESIDENTS_DESKTOP_COLORS } from '@/constants/residents/desktop/color';
import { StyleSheet } from 'react-native';

export interface TabItem {
  key: string;
  title: string;
  subtitle: string;
  count?: number;
  borderColor: string;
}

interface DesktopTabsHeaderProps {
  tabs: TabItem[];
  activeTab: string;
  onTabChange: (tabKey: string) => void;
  style?: ViewStyle;
}

export const DesktopTabsHeader: React.FC<DesktopTabsHeaderProps> = ({
  tabs,
  activeTab,
  onTabChange,
  style,
}) => {
  return (
    <View style={[styles.tabs, style]}>
      {tabs.map((tab) => (
        <TouchableOpacity
          key={tab.key}
          accessibilityRole="button"
          onPress={() => onTabChange(tab.key)}
          style={[styles.tabItem, activeTab === tab.key && styles.tabItemActive]}
        >
          <View style={styles.tabHeaderRow}>
            <Text style={[styles.tabTitleText, activeTab === tab.key && styles.tabTitleTextActive]}>
              {tab.title}
            </Text>
            {tab.count !== undefined && (
              <View style={[styles.countPill, tab.count === 0 && styles.countPillHidden]}>
                <Text style={styles.countPillText}>{tab.count}</Text>
              </View>
            )}
          </View>
          <Text style={styles.subTitleText}>
            {tab.subtitle}
          </Text>
          <View 
            style={[
              styles.activeBorder, 
              activeTab === tab.key && { backgroundColor: tab.borderColor }
            ]} 
          />
        </TouchableOpacity>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  tabs: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingTop: 16,
    marginBottom: 24,
    gap: 16,
  },
  tabItem: {
    flex: 1,
    backgroundColor: RESIDENTS_DESKTOP_COLORS.PRIMARY_BACKGROUND,
    borderRadius: 16,
    overflow: 'hidden',
    borderBottomWidth: 4,
    borderBottomColor: 'transparent',
    paddingTop: 24,
    paddingBottom: 24,
    paddingHorizontal: 24,
  },
  tabItemActive: {
    backgroundColor: RESIDENTS_DESKTOP_COLORS.CIRCLE_ICON_BACKGROUND,
  },
  tabHeaderRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  tabTitleText: {
    color: RESIDENTS_DESKTOP_COLORS.TEXT_PRIMARY,
    fontSize: 20,
    fontWeight: '800',
  },
  tabTitleTextActive: {
    color: RESIDENTS_DESKTOP_COLORS.TEXT_PRIMARY,
  },
  subTitleText: {
    color: RESIDENTS_DESKTOP_COLORS.TEXT_TERTIARY,
    fontSize: 13,
    opacity: 0.65,
  },
  countPill: {
    minWidth: 28,
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.2)',
    alignItems: 'center',
  },
  countPillHidden: {
    opacity: 0,
  },
  countPillText: {
    color: RESIDENTS_DESKTOP_COLORS.TEXT_PRIMARY,
    fontWeight: '700',
  },
  activeBorder: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    height: 4,
    backgroundColor: 'transparent',
  },
});
